import Vue from 'vue';

import Sluzby from './components/Sluzby.vue'
// import SluzbaDetail from './components/SluzbaDetail.vue'

console.log("sluzby.js");

new Vue({
  el: '#sluzbyApp',
  components: {
    'sluzby': Sluzby,
    // 'sluzba-detail': SluzbaDetail,
  }
});